<template>
  <div id="content-container">
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="100px"
          inline
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="关键字">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="搜索井号、井队、区块"
              @keyup.enter.native="query()"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属基地">
            <BaseSelect
              v-model="filter.base_id"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable>
              <el-option label="正常" :key="1" :value="1"></el-option>
              <el-option label="已归档" :key="100" :value="100"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始服务日期">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="完工日期">
            <el-date-picker
              v-model="filter.serve_end_date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 100px">
          <el-button type="primary" size="small" @click="query()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="
          model = {}
          dialogVisible = true
        "
        v-permission="Auth.drillWellNew"
        >新增钻井</el-button
      >
      <el-table :data="list" size="small" class="mt-10">
        <el-table-column prop="well_number" label="井号"> </el-table-column>
        <el-table-column prop="well_team" label="井队"></el-table-column>
        <el-table-column prop="well_block" label="区块"></el-table-column>
        <el-table-column prop="base.name" label="所属基地"></el-table-column>
        <el-table-column prop="service_staff_names" label="服务人员">
          <template slot-scope="scope">{{
            scope.row.service_staff_names.join('、')
          }}</template>
        </el-table-column>
        <el-table-column
          prop="start_serve_date"
          label="开始服务日期"
        ></el-table-column>
        <el-table-column
          prop="end_serve_date"
          label="完工日期"
        ></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 1 ? 'text-success' : 'text-muted'"
            >
              <ItemStatus
                :status="scope.row.status"
                model="drillWell"
              ></ItemStatus>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.status == 1"
              title="确认删除该钻井吗？"
              @confirm="hanldeDelte(scope.row, scope.$index)"
            >
              <el-button
                slot="reference"
                v-permission="Auth.drillWellDelete"
                type="text"
                size="small"
                class="text-danger"
                >删除</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.drillWellArchive"
              :title="`${
                scope.row.status == 1
                  ? '归档后将无法再添加使用数据，确认归档吗？'
                  : '确认恢复吗？'
              }`"
              @confirm="handleDrillArchive(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                type="text"
                size="small"
                class="ml-5"
                >{{ scope.row.status == 1 ? '归档' : '恢复' }}</el-button
              >
            </el-popconfirm>
            <el-button
              v-if="scope.row.status == 1"
              type="text"
              size="small"
              class="ml-5"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.drillWellEdit"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              class="ml-5"
              @click="$router.push(`/drill_wells/${scope.row.id}`)"
              v-permission="Auth.drillWellDetail"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <Former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></Former>
    </div>
  </div>
</template>

<script>
import {
  drillWellList,
  drillWellDelete,
  drillWellDeleteStatus,
} from '@/service/getData'
import Former from './former'
import BaseSelect from '@/components/select/base_select.vue'

export default {
  components: {
    Former,
    BaseSelect,
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
  },
  data() {
    return {
      model: {},
      filter: {
        page: 1,
        size: 10,
        status: '',
        query: '',
        base_id: '',
        date: '',
        serve_end_date: '',
      },
      total: 0,
      editIndex: 0,
      list: [],
      dialogVisible: false,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    query() {
      this.filter.page = 1
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      let params = this.clone(this.filter)
      params.page -= 1
      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      if (params.serve_end_date && params.serve_end_date.length == 2) {
        params.end_serve_date_start = params.serve_end_date[0]
        params.end_serve_date_end = params.serve_end_date[1]
      }

      let res = await drillWellList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item) {
      this.model = this.clone(item)
      this.editIndex = index
      this.dialogVisible = true
    },
    async hanldeDelte(item, index) {
      let res = await drillWellDelete(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    async handleDrillArchive(index, id) {
      let res = await drillWellDeleteStatus({ id: id })
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },
    reset() {
      this.filter.page = 1
      this.filter.query = ''
      this.filter.status = ''
      this.filter.base_id = ''
      this.filter.date = ''
      this.filter.serve_end_date = ''
      this.getData()
    },
  },
}
</script>